import { ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CallState } from '@lcs/shared/api';
import { Store, select } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { LcsDialogService } from 'src/app/common-components/dialog/dialog.service';
import { FormComponent } from 'src/app/common-components/forms-base/form-component.interface';
import { ScheduleDetailFormService } from '../../schedule-details/services/schedule-detail-form.service';
import { AddScheduleData } from '../models/add-schedule-data';
import { createSchedule } from '../state/add-schedule.actions';
import { getAddScheduleCallState } from '../state/add-schedule.selectors';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    providers: [ScheduleDetailFormService],
    selector: 'ndt-add-schedule',
    styleUrls: ['./add-schedule.component.scss'],
    templateUrl: './add-schedule.component.html',
    standalone: false
})
export class AddScheduleComponent implements OnInit, OnDestroy, FormComponent {
   callState: Observable<CallState>;

   form: UntypedFormGroup;

   private destroyed$ = new Subject<void>();

   constructor(
      protected store: Store,
      protected formService: ScheduleDetailFormService,
      private fb: UntypedFormBuilder,
      @Inject(MAT_DIALOG_DATA) public data: AddScheduleData,
      private dialogService: LcsDialogService,
      public dialogRef: MatDialogRef<AddScheduleComponent>
   ) {
      this.form = this.fb.group({
         schedule: this.fb.control(null),
      });
      this.callState = this.store.pipe(select(getAddScheduleCallState));
   }

   ngOnInit(): void {
      this.form = this.formService.form;
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }

   onCloseClick(): void {
      this.dialogService.close();
   }

   onCreate(): void {
      if (this.form.valid) {
         const schedule = this.formService.getValue(null);
         this.store.dispatch(
            createSchedule({
               schedule,
            })
         );
      }
      this.dialogRef.close(this.form.value);
   }
}
